import PropTypes, { func } from "prop-types";
import React, { Fragment, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { connect } from "react-redux";
import { addToCart } from "../../redux/actions/cartActions";
import { addToWishlist } from "../../redux/actions/wishlistActions";
import "./table.css";
import _ from "lodash";
import { BsEnvelope } from "react-icons/bs";
import { useToasts } from "react-toast-notifications";

const ProductGridQta = (props) => {
  const {
    product,
    spaceBottomClass,
    spaceTopClass,
    addToCart,
    addToWishlist,
    cartItems,
    userData,
    isLoggedUser,
    visualizzaPrezzi,
    visualizzaGriglia,
    visualizzaQuantita,
    getDisponibili,
    getQtaInArrivo,
    toColor,
    productCartQty,
    setQta,
    table,
    onBlur,
    qta,
    variations,
    numTaglie,
  } = props;

  const history = useHistory();
  const [onlyPromo, setOnlyPromo] = useState(
    JSON.parse(sessionStorage.getItem("filter"))?.tag?.includes("OUTLET")
  );

  const { addToast } = useToasts();

  function calcolaColoreCella(
    QtaDisponibili,
    QtaArrivo,
    selectedProductColor,
    selectedProductSize,
    catalogo
  ) {
    if (catalogo == 1) return "white"; //return "lightyellow"
    if (
      QtaDisponibili -
        productCartQty(selectedProductColor, selectedProductSize) >
      0
    )
      return "white";
    if (
      QtaDisponibili +
        QtaArrivo -
        productCartQty(selectedProductColor, selectedProductSize) >
      0
    )
      return "white";
    return "white";
    //return "#ffa5002f"
  }

  function onPlusMinusClick(
    bPlus,
    bMsg,
    idArt,
    QtaDisponibili,
    QtaArrivo,
    catalogo,
    promo
  ) {
    var element = document.getElementById(idArt);
    var QtaOrdinate = 0;

    if (bPlus) QtaOrdinate = (element.value ? parseInt(element.value) : 0) + 1;
    else QtaOrdinate = parseInt(element.value) - 1;

    onBlur(idArt, QtaOrdinate, QtaDisponibili, QtaArrivo, catalogo, promo);
  }

  const clearAll = () => {
    var elements = document.querySelectorAll('[data-type="' + "InsQta" + '"]');
    for (var ii = 0; ii < elements.length; ii++) {
      elements[ii].value = 0;
    }
    setQta(table);
  };

  useEffect(() => {
    var elements = document.querySelectorAll('[data-type="' + "InsQta" + '"]');
    for (var ii = 0; ii < elements.length; ii++) {
      elements[ii].value = 0;
    }
  }, [product]);

  const confirmAll = () => {
    var addedAtLeastOne = false;
    if (cartItems.length >= 100) {
      addToast(
        "Limite carrello superato. Procedi con l'invio di questo ordine e caricane uno nuovo per gli articoli rimanenti",
        { appearance: "error", autoDismiss: false, placement: "top-center" }
      );
      return;
    }
    qta.map((s, key) => {
      if (s)
        s.map((single, key) => {
          if (single.qta > 0) {
            addedAtLeastOne = true;
            product.catalogo = single.catalogo;
            addToCart(
              product,
              null,
              single.qta,
              single.color,
              single.name,
              single.IDArtSizeColor,
              single.Ord1,
              single.Ord2
            );
          }
        });
    });

    if (addedAtLeastOne) {
      addToast("Quantità aggiunte al carrello", {
        appearance: "success",
        autoDismiss: true,
        placement: "bottom-left",
      });
      clearAll();
    }
  };

  const clearAllVar = (variant) => {
    var elements = document.querySelectorAll('[data-color="' + variant + '"]');
    for (var ii = 0; ii < elements.length; ii++) {
      elements[ii].value = "0";
    }
    setQta((prevState) =>
      prevState.map((row) =>
        row?.map((col) => (col.color == variant ? { ...col, qta: 0 } : col))
      )
    );
  };

  function isTooDark(hexcolor) {
    hexcolor = hexcolor.replace("#", "");
    var r = parseInt(hexcolor.substr(0, 2), 16);
    var g = parseInt(hexcolor.substr(2, 2), 16);
    var b = parseInt(hexcolor.substr(4, 2), 16);
    var yiq = (r * 299 + g * 587 + b * 114) / 1000;
    return yiq >= 128 ? "black" : "white";
  }

  function inserisciInPromemoria(IDArt, IDCli, IdDetCliRef) {
    //alert(IDArt + " " +IDCli)
    var body =
      "{IDArt:" +
      IDArt +
      ",IDCli:" +
      IDCli +
      ", IdDetCliRef: " +
      IdDetCliRef +
      "}";
    //console.log(credentials);
    //console.log(body);

    var endpoint = global.endpoint + "/pegaso/addArtInPromemoria";
    fetch(endpoint, {
      method: "POST",
      headers: new Headers({
        "Content-Type": "application/x-www-form-urlencoded",
      }),
      body: body,
      withCredentials: false,
    })
      .then((res) => res.json())
      .then((result) => {
        if (result.Errore)
          addToast(result.Errore, {
            appearance: "error",
            autoDismiss: true,
            placement: "bottom-left",
          });
        else
          addToast(result.Risposta, {
            appearance: "success",
            autoDismiss: true,
            placement: "bottom-left",
          });
      });
  }

  function contaPromo(single) {
    var conta = 0;
    for (var i = 0; i < single?.size.length; i++) {
      if (single.size[i].promo) conta++;
    }
    return conta;
  }

  if (!visualizzaGriglia) return null;

  function checkVisibility(single) {
    var conta = 0;
    for (var i = 0; i < single?.size.length; i++) {
      if (single.size[i].flgNoWeb) conta++;
    }
    return conta == single.size.length;
  }
  return (
    <Fragment>
      <div
        className="shopping-cart-btn btn-hover text-center"
        style={{ marginBottom: "50px" }}
      >
        <a className="default-btn" onClick={() => confirmAll()}>
          {" "}
          Aggiungi al carrello{" "}
        </a>
        <a
          className="default-btn"
          onClick={() => {
            confirmAll();
            history.push("/shop-grid-full-width");
          }}
        >
          {" "}
          Continua con gli acquisti{" "}
        </a>
      </div>
      {variations[numTaglie]?.size && (
        <div>
          <div
            style={{ margin: "auto", width: "100%" }}
            className={
              `shop-area ${spaceTopClass ? spaceTopClass : ""} ${
                spaceBottomClass ? spaceBottomClass : ""
              }` + " table-content table-responsive cart-table-content"
            }
          >
            <br></br>
            {/* 
                <div className="pro-details-cart btn-hover"><button onClick={() => clearAll()}> Cancella tutto</button></div>
*/}
            <div className="tableContainer">
              <table id="qtaTable">
                <thead>
                  <tr style={{ border: "1px solid #e5e5e5", width: "100%" }}>
                    <th style={{ fontSize: "12px" }}>Colore/Taglia</th>
                    {variations[numTaglie].size.map((single, key) => {
                      return <th>{single.name}</th>;
                    })}
                    <th
                      style={{
                        display: "inline-block",
                        minWidth: "30px",
                        maxWidth: "30px",
                      }}
                    ></th>
                  </tr>
                </thead>
                <tbody>
                  {variations.map((single, key) => {
                    return single.size == undefined ||
                      single.size?.length == 0 ||
                      (onlyPromo && contaPromo(single) == 0) ? (
                      <></>
                    ) : (
                      <tr
                        style={{
                          border: "1px solid #e5e5e5",
                          width: "100%",
                          display: checkVisibility(single)
                            ? "none"
                            : "table-row",
                        }}
                      >
                        <td>
                          <div
                            style={{
                              backgroundColor: toColor(single.hexColor),
                              paddingTop: "60%",
                              height: "200px",
                              zIndex: 2,
                              backgroundImage: single.hexColor
                                ? null
                                : "url('https://dgaplanetshirt.com/assets/img/COLORI/" +
                                  single.color.split("-")[0] +
                                  ".png')",
                              backgroundSize: "100% 100%",
                              color: single.hexColor
                                ? isTooDark(toColor(single.hexColor))
                                : "gray",
                            }}
                          >
                            <img
                              src={global.baseUrlImage + single.image[0]}
                              style={{
                                display: "none",
                                height: "160px",
                                zIndex: 1,
                                opacity: "50%",
                                borderRadius: "20%",
                              }}
                            ></img>
                            <p
                              style={{
                                color: single.hexColor
                                  ? isTooDark(toColor(single.hexColor))
                                  : "gray",
                                backgroundColor: single.hexColor
                                  ? "transparent"
                                  : "#FFFFFFDC",
                              }}
                            >
                              {single.color.split("-")[1].split(" (")[0]} <br />{" "}
                              {single.color.split("-")[1].split(" (")[1]
                                ? "(" +
                                  single.color.split("-")[1].split(" (")[1]
                                : ""}
                            </p>
                          </div>
                        </td>
                        {single.size?.map((s, key) => {
                          //console.log(s)
                          var qtaInCarrello = productCartQty(s.color, s.name);
                          return s.flgNoWeb == 1 ||
                            !s.pricesco ||
                            s.pricesco <= 0 ||
                            (!s.promo && onlyPromo) ? (
                            <td></td>
                          ) : (
                            <td
                              style={{
                                backgroundColor: calcolaColoreCella(
                                  s.stock,
                                  s.qtaOrdFor,
                                  s.color,
                                  s.name,
                                  s.catalogo
                                ),
                                backgroundRepeat: "no-repeat",
                                backgroundSize: "contain",
                              }}
                              id={s.name + s.color}
                              //onMouseEnter={() => {
                              //    document.getElementById(s.name + s.color).style.backgroundImage =
                              //       visualizzaPrezzi ?
                              //</tr>            'url("https://placehold.jp/23/ffffff/000000/270x400.png?text=Taglia: ' + s.name + /*'%0AColore: ' + s.color + */'")'
                              //            :
                              //            'url("https://placehold.jp/23/ffffff/000000/270x150.png?text=Taglia: ' + s.name + /*'%0AColore: ' + s.color + */'")'
                              //}}

                              onMouseLeave={() => {
                                document.getElementById(
                                  s.name + s.color
                                ).style.backgroundImage = null;
                              }}
                            >
                              {qtaInCarrello > 0 && (
                                <div
                                  className="header-right-wrap"
                                  style={{
                                    marginTop: "-10px",
                                    justifyContent: "left",
                                    position: "sticky",
                                    float: "left",
                                  }}
                                >
                                  <div className="same-style cart-wrap">
                                    <button
                                      className="icon-cart"
                                      disabled
                                      style={{ cursor: "none" }}
                                    >
                                      <span className="count-style">
                                        {qtaInCarrello}
                                      </span>
                                    </button>
                                  </div>
                                </div>
                              )}
                              {s.promo && (
                                <div
                                  className="header-right-wrap"
                                  style={{
                                    marginTop: "-10px",
                                    justifyContent: "left",
                                    position: "sticky",
                                    float: "left",
                                  }}
                                >
                                  <div className="same-style cart-wrap">
                                    <img
                                      src="https://findicons.com/files/icons/767/wp_woothemes_ultimate/256/sale.png"
                                      height={"40"}
                                    />
                                  </div>
                                </div>
                              )}
                              {/*   <td style={{ textAlign: "center", backgroundColor: (s.stock <= 0) ? "lightgray" : "white"}}>}*/}
                              {visualizzaPrezzi && (
                                <div style={{ textAlign: "right" }}>
                                  <h6
                                    style={{
                                      display:
                                        s.priceOld > 0 &&
                                        s.pricesco < s.priceOld
                                          ? "inline"
                                          : "none",
                                    }}
                                  >
                                    <del>
                                      {"€ " +
                                        (s.priceOld
                                          ? ((s.priceOld * 100) / 100).toFixed(
                                              2
                                            )
                                          : "0")}
                                    </del>
                                  </h6>
                                  <h5
                                    style={{
                                      textAlign: "right",
                                      color: "green",
                                      fontWeight: "600",
                                      display: "inline",
                                    }}
                                  >
                                    {" "}
                                    {"€ " +
                                      (s.pricesco
                                        ? ((s.pricesco * 100) / 100).toFixed(2)
                                        : "0")}{" "}
                                    <br />
                                    <span
                                      style={{
                                        fontSize: "10px",
                                        marginTop: "-15px",
                                      }}
                                    >
                                      {userData.user.user?.ParIva ||
                                      userData.user.user?.ParIva != "" ||
                                      userData.user.user?.ParIva != null
                                        ? "Iva esclusa"
                                        : ""}
                                    </span>
                                  </h5>
                                </div>
                              )}

                              {s.stock <= 0 &&
                              s.stock - s.qtaOrdFor <= 0 &&
                              s.qtaOrdFor - s.qtaImpCli <= 0 &&
                              s.tag?.includes("PROMEMORIA") ? (
                                <div
                                  className="shopping-cart-btn text-center"
                                  style={{
                                    height: "60px",
                                    borderColor: "white",
                                  }}
                                >
                                  <a
                                    className="default-btn"
                                    style={{
                                      display: "flex",
                                      flexDirection: "column",
                                      padding: 5,
                                      alignItems: "center",
                                      justifyContent: "center",
                                      marginTop: 100,
                                      paddingBottom: 0,
                                      borderColor: "gray",
                                    }}
                                    onClick={() =>
                                      inserisciInPromemoria(
                                        s.IDArtSizeColor,
                                        userData.user.user.IDCli,
                                        userData.user.user.IdDetCliRef
                                      )
                                    }
                                  >
                                    <div style={{ fontSize: "12px" }}>
                                      Avvisami quando torna disponibile
                                    </div>
                                    <BsEnvelope size={30} />
                                  </a>
                                </div>
                              ) : (
                                <>
                                  <h6
                                    style={{
                                      textAlign: "right",
                                      paddingTop: "1%",
                                    }}
                                  >
                                    <span
                                      style={{
                                        backgroundColor: "gray",
                                        borderRadius: "10px",
                                        padding: "3%",
                                        color: "white",
                                      }}
                                    >
                                      Taglia {s.name}
                                    </span>
                                  </h6>
                                  <h5
                                    style={{
                                      textAlign: "right",
                                      height: "20px",
                                    }}
                                  >
                                    {getDisponibili(
                                      s.stock,
                                      s.qtaOrdFor,
                                      s.color,
                                      s.name,
                                      s.catalogo,
                                      s.qtaImpCli,
                                      s.promo
                                    )}
                                  </h5>
                                  {/*<h6 style={{ textAlign: "right" }}>{s.DataArrivo}</h6>*/}
                                  <h6
                                    style={{
                                      textAlign: "right",
                                      whiteSpace: "pre",
                                      fontSize: "12px",
                                    }}
                                  >
                                    {getQtaInArrivo(
                                      s.qtaOrdFor,
                                      s.qtaImpCli,
                                      s.stock,
                                      s.catalogo,
                                      s.promo
                                    ) || ""}
                                  </h6>

                                  {visualizzaPrezzi && (
                                    <div
                                      style={{ border: "1px solid #e5e5e5" }}
                                    >
                                      <button
                                        onClick={() =>
                                          onPlusMinusClick(
                                            false,
                                            true,
                                            s.IDArtSizeColor,
                                            s.stock,
                                            s.qtaOrdFor,
                                            s.catalogo,
                                            s.promo
                                          )
                                        }
                                        style={{
                                          background: "none",
                                          border: "none",
                                          padding: 0,
                                          color: "#8f8f8f",
                                          cursor: "pointer",
                                          float: "inherit",
                                          fontSize: "20px",
                                        }}
                                      >
                                        -
                                      </button>
                                      <input
                                        id={s.IDArtSizeColor}
                                        defaultValue={"0"}
                                        data-size={s.name}
                                        data-color={single.color}
                                        data-type={"InsQta"}
                                        style={{
                                          width: "40%",
                                          textAlign: "center",
                                          backgroundColor: calcolaColoreCella(
                                            s.stock,
                                            s.qtaOrdFor,
                                            s.color,
                                            s.name,
                                            s.catalogo
                                          ),
                                          padding: 0,
                                          border: "none",
                                          fontSize: "14px",
                                        }}
                                        type="numeric"
                                        onBlur={(e) =>
                                          onBlur(
                                            s.IDArtSizeColor,
                                            parseInt(e.target.value) === 0
                                              ? 0
                                              : e.target.value,
                                            s.stock,
                                            s.qtaOrdFor,
                                            s.catalogo,
                                            s.promo
                                          )
                                        }
                                        onChange={(e) =>
                                          onBlur(
                                            s.IDArtSizeColor,
                                            parseInt(e.target.value) === 0
                                              ? 0
                                              : e.target.value,
                                            s.stock,
                                            s.qtaOrdFor,
                                            s.catalogo,
                                            s.promo
                                          )
                                        }
                                      />
                                      <button
                                        onClick={() =>
                                          onPlusMinusClick(
                                            true,
                                            true,
                                            s.IDArtSizeColor,
                                            s.stock,
                                            s.qtaOrdFor,
                                            s.catalogo,
                                            s.promo
                                          )
                                        }
                                        style={{
                                          background: "none",
                                          border: "none",
                                          padding: 0,
                                          color: "#8f8f8f",
                                          cursor: "pointer",
                                          float: "inherit",
                                          fontSize: "20px",
                                        }}
                                      >
                                        +
                                      </button>
                                    </div>
                                  )}
                                </>
                              )}
                            </td>
                          );
                        })}
                        {isLoggedUser && (
                          <td
                            style={{
                              display: "inline-block",
                              minWidth: "30px",
                              maxWidth: "30px",
                              height: "100%",
                            }}
                          >
                            <button
                              onClick={() => clearAllVar(single.color)}
                              style={{
                                backgroundColor: "white",
                                border: "none",
                                padding: 0,
                                zIndex: 9999,
                              }}
                              type="button"
                              aria-label="Close"
                            >
                              <span
                                data-toggle="tooltip"
                                title="Cancella l'intera riga!"
                                className="cancelRow"
                                aria-hidden="true"
                              >
                                <i class="fa fa-trash"></i>
                              </span>
                            </button>
                          </td>
                        )}
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
          <br></br>
          <div
            className="shopping-cart-btn btn-hover text-center"
            style={{ marginBottom: "50px" }}
          >
            <a className="default-btn" onClick={() => confirmAll()}>
              {" "}
              Aggiungi al carrello{" "}
            </a>
            <a
              className="default-btn"
              onClick={() => {
                confirmAll();
                history.push("/shop-grid-full-width");
              }}
            >
              {" "}
              Continua con gli acquisti{" "}
            </a>
          </div>
        </div>
      )}
    </Fragment>
  );
};

ProductGridQta.propTypes = {
  product: PropTypes.object,
  addToCart: PropTypes.func,
  addToWishlist: PropTypes.func,
  cartItems: PropTypes.array,
};

const mapDispatchToProps = (dispatch) => {
  return {
    addToCart: (
      item,
      addToast,
      quantityCount,
      selectedProductColor,
      selectedProductSize,
      selectedIDArt,
      Ord1,
      Ord2
    ) => {
      dispatch(
        addToCart(
          item,
          addToast,
          quantityCount,
          selectedProductColor,
          selectedProductSize,
          selectedIDArt,
          Ord1,
          Ord2
        )
      );
    },

    addToWishlist: (item, addToast) => {
      dispatch(addToWishlist(item, addToast));
    },
  };
};

const mapStateToProps = (state) => {
  return {
    cartItems: state.cartData,
    userData: state.userData,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ProductGridQta);
